export type NotificationPreflight =
  | { action: "fail-campaign"; reason: "missing-content" }
  | {
      action: "dual-provider-failed";
      reason: "missing-profile" | "missing-user";
    }
  | { action: "send-providers" };

export function classifyNotificationPreflight(input: {
  eventId?: string | null;
  title: string;
  body: string;
  profile?: { id: string } | null;
  receiverUserId?: string | null;
}): NotificationPreflight {
  if (!input.eventId || !input.title || !input.body) {
    return { action: "fail-campaign", reason: "missing-content" };
  }
  if (input.profile === null) {
    return { action: "dual-provider-failed", reason: "missing-profile" };
  }
  if ("receiverUserId" in input && !input.receiverUserId) {
    return { action: "dual-provider-failed", reason: "missing-user" };
  }
  return { action: "send-providers" };
}
